export const BASE_URL = import.meta.env.VITE_BASE_URL as string;
export const isDevelopment = import.meta.env.DEV as boolean;
export const isProduction = import.meta.env.PROD as boolean;
